export default __webpack_public_path__ + "static/card-rectangle-04add52280560a41e000f133dcf08dd8.jpg";